import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiMapSectionDTO,
  MapSectionDTO,
} from "@lib/strapi/dtos/components/sections/mapSection.dto";
import { parseStrapiContent } from "@lib/strapi/content";

export class MapSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiMapSectionDTO,
  ): Promise<MapSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new MapSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.latitude = strapiData.latitude;
    dto.longitude = strapiData.longitude;
    dto.zoom = strapiData.zoom;
    dto.showDirections = strapiData.showDirections;
    dto.directions = await parseStrapiContent(strapiData.directions);
    dto.invite = strapiData.invite;
    return dto;
  }
}
